export default "__VITE_PUBLIC_ASSET__0897fbb1__"